import { CompanyStateInterface } from "./types";
import Company from "@/types/app/companies";

export default {
 
  getModalCompanyState(state: CompanyStateInterface): boolean {
    return state.modalCompany;
  },
  getCompanyState(state: CompanyStateInterface): Company {
    return state.company;
  },
  getCompaniesState(state: CompanyStateInterface): Company[] {
    return state.companies;
  },
  getCompanySent(state: CompanyStateInterface): boolean {
    return state.companySent;
  },
};
